// 守狸 Web 入口（P8 SSO）：轻量 router（/ 工作台 · /login 身份入口 · /callback PKCE 回调）
// + mount 前 sdk.bootstrap() 凭 account 会话 cookie 静默续登（零 redirect 进入）。
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import Workspace from './pages/Workspace.vue'
import Login from './pages/Login.vue'
import OAuthCallback from './pages/OAuthCallback.vue'
import './styles.css'
import { sdk, isAuthed } from './lib/sdk'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'workspace', component: Workspace, meta: { requiresAuth: true } },
    { path: '/login', name: 'login', component: Login },
    // /callback：SDK startPKCE/exchangePKCE 内部硬编码 redirect_uri = origin + '/callback'，
    // 与生态约定一致（plan 13 收敛方案 B：全 web SPA 统一 /callback）。
    { path: '/callback', name: 'oauth-callback', component: OAuthCallback },
    // 兜底：未知路径回工作台（guard 再据登录态分流）。
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach((to) => {
  // 已登录还落到 /login（手输地址 / 静默进入后残留）→ 直接回工作台。
  if (to.name === 'login' && isAuthed()) return { path: '/' }
  // 未登录访问受保护路由 → 去登录页。
  if (to.meta.requiresAuth && !isAuthed()) return { name: 'login' }
  return true
})

async function main() {
  // mount 前凭 host-only 会话 cookie 静默换 access token + 拉 user；
  // 有会话 → isAuthed() 真，guard 放行 /；无会话 → 打回 /login。失败不阻塞首屏。
  await sdk.bootstrap().catch(() => false)
  const app = createApp(App)
  app.use(router)
  app.mount('#app')
}

main()
